import CustomerReferralAccount from '@sectionsJS/customer-referral/account.js';

document.addEventListener('DOMContentLoaded', () => {
  new CustomerReferralAccount();
});
